import React from 'react';
import { Button, DropdownButton } from 'components';

type Props = {
  row: any;
  value: boolean | null;
  columnId: string;
  setTableData: React.Dispatch<any>;
  onChange: (value: boolean | null, row: any) => void;
  onRemove: (row: any) => void;
};

const AvailabilityCell = ({ row, value, columnId, setTableData, onChange, onRemove }: Props) => {
  const updateValue = (newValue: boolean | null) => {
    setTableData((prev: any) => {
      if (!prev?.items) return prev;

      return {
        ...prev,
        items: prev.items.map((item: any) => (item.id === row.id ? { ...item, [columnId]: newValue } : item))
      };
    });

    onChange(newValue, row);
  };

  const label = value === true ? 'Available' : 'Unknown';

  return (
    <DropdownButton
      button={<Button tiny variant={value === true ? 'success' : 'alternative'} text={label} />}
      items={[
        { text: 'Unknown', selected: value !== true, onClick: () => updateValue(null) },
        { text: 'Available', selected: value === true, onClick: () => updateValue(true) },
        { text: 'Remove', onClick: () => onRemove(row) }
      ]}
      align="start"
    />
  );
};

export default AvailabilityCell;
